import { NameDto } from '@/api/Common/Types'

interface SpinRewardConfiguration {
  amountOfSpins: number
  luckyDrawCampaignId: string
}

interface BonusRewardConfiguration {
  bonusCampaignId: string
}

interface TradingViewConfiguration {
  tradingViewPlanId: string
}

export interface RewardsHubCreateDto {
  internalName: string
  displayName: string
  rewardCategoryId: number
  rewardStatusId: number
  defaultExpirationInDays: number
  spinRewardConfiguration: SpinRewardConfiguration | null
  bonusRewardConfiguration: BonusRewardConfiguration | null
  tradingViewRewardConfiguration: TradingViewConfiguration | null
}

export interface RewardsHubDto {
  id: string
  internalName: string
  displayName: string
  rewardCategory: {
    id: number
    name: string
  }
  propertyValue: number
  rewardStatus: {
    id: number
    name: string
  }
  rewardUsage: number
  defaultExpirationInDays: number
  lastModified: string
  spinRewardConfiguration: {
    amountOfSpins: number
    luckyDrawCampaign: {
      id: string
      name: string
    }
  } | null
  bonusRewardConfiguration: {
    bonusCampaign: {
      id: string
      name: string
    }
  } | null
  tradingViewRewardConfiguration: {
    tradingViewPlan: {
      id: number
      name: string
    }
  } | null
}

export interface RewardProgramDto {
  id: string
  internalName: string
  programStatus: NameDto
  trackingMetrics: NameDto[]
  numberOfTiers: number
}

export enum RewardsHubTab {
  MANAGER = 'rewards-type-manager',
  PROGRAMS = 'reward-programs',
}

export enum RewardsHubKeys {
  id = 'id',
  internalName = 'internalName',
  displayName = 'displayName',
  category = 'rewardCategory.name',
  propertyValue = 'propertyValue',
  status = 'rewardStatus.name',
  usage = 'rewardUsage',
  lastModified = 'lastModified',
  amountOfSpins = 'spinRewardConfiguration.amountOfSpins',
  expirationInDays = 'defaultExpirationInDays',
}

export enum RewardProgramsKey {
  id = 'id',
  internalName = 'internalName',
  programStatus = 'programStatus.name',
  trackingMetrics = 'trackingMetrics',
  numberOfTiers = 'numberOfTiers',
}

export enum RewardStatuses {
  ACTIVE = 1,
  DISABLED = 2,
}

export const RewardStatusArray = [
  { id: 1, name: 'Active' },
  { id: 2, name: 'Disabled' },
]

export enum RewardCategories {
  SPIN = 1,
  BONUS = 2,
  TRADING_VIEW = 3,
}

export const TradingViewRewardType = [
  { id: 1, name: 'Essential' },
  { id: 2, name: 'Plus' },
  { id: 3, name: 'Premium' },
]

export enum RewardHubFilterKey {
  INTERNAL_NAME = 'InternalName',
  DISPLAY_NAME = 'DisplayName',
  REWARD_CATEGORY = 'RewardCategory',
  PROPERTY_VALUE = 'PropertyValue',
  REWARD_STATUS = 'RewardStatus',
  REWARD_USAGE = 'RewardUsage',
  DEFAULT_EXPIRATION_IN_DAYS = 'DefaultExpirationInDays',
  LAST_MODIFIED = 'LastModified',
  AMOUNT_OF_SPINS = 'AmountOfSpins',
  LUCKY_DRAW = 'LuckyDraw',
  BONUS_CAMPAIGN = 'BonusCampaign',
  TRADING_VIEW_PLAN_ID = 'TradingViewPlanId',
}

export enum RewardProgramFilterKey {
  INTERNAL_NAME = 'InternalName',
  PROGRAM_STATUS = 'RewardProgramStatus',
  NUMBER_OF_TIERS = 'NumberOfTiers',
  TRACKING_METRICS = 'TrackingMetric',
}
